export default "__VITE_ASSET__qlO5xBns__"